import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/layouts/empty.vue").then(m => m.default || m))
}